import vanillaTextMask from 'vanilla-text-mask/dist/vanillaTextMask'

import getById from 'utils/DOM/getById'
import setValueText from './setValueText'
import updateDOM from './updateDOM'
import setErrorMessage from './setErrorMessage'

const baseControllerInput = config => ({
  input,
  typeMember,
  callOnValidate = undefined,
  callOnFocus,
  getSdate,
  showError = setErrorMessage
}) => {
  const id = input.id || input.name
  const state = {
    input,
    typeMember,
    wrap: getById(`wrap-${id}`),
    errorWrap: getById(`error-${id}`),
    valid: false,
    error: false,
    showError
  }

  let maskedInputController
  if (config.maskConfig) {
    maskedInputController = vanillaTextMask(
      Object.assign({ inputElement: input }, config.maskConfig)
    )
  }

  const validate = state => {
    const error = config.getErrorMessage(state, getSdate ? getSdate() : undefined)

    if (error) {
      state.showError(state, error)
    } else {
      state.error = false
      state.valid = true
    }

    updateDOM(state)
    if (callOnValidate) {
      callOnValidate(state)
    }
  }

  function handleBlur() {
    validate(state)
  }

  input.addEventListener('blur', handleBlur)

  function handleFocus() {
    if (state.error) {
      state.error = false
      updateDOM(state)
    }
    if (callOnFocus) {
      callOnFocus(state)
    }
  }

  input.addEventListener('focus', handleFocus)

  return {
    reset: () => {
      state.error = false
      state.valid = false
      state.input.value = ''

      updateDOM(state)
    },
    setValue: value => {
      setValueText(state, config.parseSetValue ? config.parseSetValue(value) : value)
    },
    getState: () => state,
    getStatus: () => ({
      valid: state.valid,
      value: state.input.value.trim()
    }),
    validate: () => {
      validate(state)
    },
    setCallOnValidate: validateFn => {
      callOnValidate = validateFn
    },
    setCallOnFocus: focusFn => {
      callOnFocus = focusFn
    },
    destroy: () => {
      if (maskedInputController) {
        maskedInputController.destroy()
      }
      input.removeEventListener('blur', handleBlur)
      input.removeEventListener('focus', handleFocus)
    }
  }
}

export default baseControllerInput
